import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-shiled-v",
  "use": "icon-icon-shiled-v-usage",
  "viewBox": "0 0 12.5 14.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.5 14.3\" id=\"icon-icon-shiled-v\"><title>资源 122</title><g id=\"icon-icon-shiled-v_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-shiled-v_图层_1-2\" data-name=\"图层 1\"><path d=\"M11.6,2.1A17.3,17.3,0,0,1,8.1.8L6.8.2A.9.9,0,0,0,5.6.2L4.4.8A19.9,19.9,0,0,1,.9,2.1,1.4,1.4,0,0,0,0,3.3V8.9a.6.6,0,0,0,.1.4,7.6,7.6,0,0,0,4.2,4.3,4.4,4.4,0,0,0,1.6.6.6.6,0,0,0,.6,0,4.3,4.3,0,0,0,1.7-.6,8,8,0,0,0,4.2-4.3c0-.1.1-.3.1-.4V3.3A1.4,1.4,0,0,0,11.6,2.1ZM3.8,11.4V4.8H3.2V4.2H5.6V7.1l3-2.9H11Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-shiled-v.svg
// module id = MlfX
// module chunks = 75